import { useEffect } from 'react';
import { APP_NAME } from './brand';

/** Titre par défaut (page sans contexte particulier). */
export const DEFAULT_TITLE = `${APP_NAME} — Préparation et simulation d'examens`;

/** `"AWS Cloud · Exam Copilot"` ; vide/null → titre par défaut. */
export function formatPageTitle(title?: string | null): string {
  const t = (title ?? '').trim();
  return t ? `${t} · ${APP_NAME}` : DEFAULT_TITLE;
}

/**
 * Met à jour le titre de l'onglet à partir d'une valeur DYNAMIQUE (nom de
 * l'examen, etc.). `null`/undefined/vide → titre par défaut de l'app.
 *
 * Utilisé par les pages de contenu (examen, pratique, simulation) qui
 * connaissent leur titre une fois leurs données chargées. Les routes statiques
 * sont gérées globalement par `<DocumentTitle />`.
 */
export function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    document.title = formatPageTitle(title);
  }, [title]);
}
